import { connect } from 'react-redux';
import { Map } from 'immutable';

import { request as openAudit } from '../../modules/audits/actions/open';
import { request as closeAudit } from '../../modules/audits/actions/close';
import { request as queryAudit } from '../../modules/audits/actions/query';
import decorate from '../../utils/decorate';

import Audits from './Audits.jsx';

function mapStateToProps(state) {
    const audits = state.audits.get('collections') || Map();

    return {
        audits: audits,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onCloseAuditRequest: (id) => dispatch(closeAudit(id)),
        onQueryAuditsRequest: (id, data) => {
            dispatch(queryAudit(id, data));
        },
    };
}

export default decorate(connect(mapStateToProps, mapDispatchToProps), Audits);
